import useLocalStorageState from 'use-local-storage-state';

export function useStoredVersionState() {
  return useLocalStorageState('storedVersion');
}
